<template>
    <div class="personalize-tickets">
        <h2 class="uk-margin-bottom">{{ $t("Personalisiere die Tickets") }}</h2>

        <ul class="uk-child-width-1-2@m uk-margin" uk-grid>
            <template v-for="(cartItem, ticketId) in selection">
                <li v-if="store.state.offers[ticketId] && !store.state.offers[ticketId].no_chip" v-for="(person, index) in cartItem.persons" :class="{['tag-'+cartItem.ticket.category.id]: true}">
                    <div class="personalize-ticket uk-position-relative">
                        <div class="ticket-details">
                            <div class="ticket-image" v-if="cartItem.ticket.image" :style="{backgroundImage: 'url('+cartItem.ticket.image+')'}">
                            </div>
                            <div class="content uk-flex uk-flex-column uk-flex-between">
                                <h4 class="uk-card-title uk-margin-remove-top" v-html="'<span>' + cartItem.ticket.name.split(' ').join('</span> <span>') + '</span>'"></h4>
                                <div class="ticket-person uk-margin-small-top">
                                    <personalize-ticket-form :ref="ref => setItemRef(ticketId, index, ref)" :person="person" @update="this.store.state.selection[ticketId].persons[index] = $event"></personalize-ticket-form>
                                </div>
                                <div class="uk-display-block">
                                    <div class="uk-text-large uk-text-bold uk-margin-top">
                                        {{ getPrice(cartItem.ticket,1) }}
                                        <div class="included-products uk-margin-small-bottom" v-if="cartItem.ticket.included_products.length" v-html="getIncludedProducts(cartItem.ticket)"></div>
                                    </div>
                                    <a @click="removeTicket(ticketId, index)"
                                       class="uk-button uk-button-primary uk-button-small">
                                        {{ $t("Ticket entfernen") }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </template>
        </ul>

        <div class="uk-margin-medium uk-flex uk-flex-right">
            <button class="uk-button uk-button-default uk-margin-small-right" @click="$emit('back')">
                {{ $t("Zurück") }}
            </button>
            <button class="uk-button uk-button-primary" @click="next">
                {{ $t("Weiter") }}
            </button>
        </div>
    </div>
</template>

<script>
import PersonalizeTicketForm from "./PersonalizeTicketForm";
import helper from "../../helper/helper";

export default {
    mixins: [helper],
    props: [],
    components: {PersonalizeTicketForm},
    data: () => {
        return {
            personRefs: {},
        };
    },
    computed: {
        selection() {
            let selection = this.store.state.selection;
            if (Object.keys(this.store.state.ownerData).length) {
                for (let offerId in selection) {
                    for (let key in this.store.state.vue_personalize_fields) {
                        if (!selection[offerId].persons[0][key] && this.store.state.ownerData[key]) {
                            selection[offerId].persons[0][key] = this.store.state.ownerData[key]
                        }
                    }
                }
            }
            return selection
        },
    },
    methods: {
        async next() {
            if (await this.validate()) {
                this.store.state.personalized = true;
                this.$emit('next');
            } else {
                window.setTimeout(() => {
                    this.$scrollTo('.vf-element-layout-error', 500, { offset: -120 });
                })
	            this.store.commit('emitScroll');
                this.store.state.personalized = false;
            }
        },
        setItemRef(ticketId, index, ref) {
            if (ref) this.personRefs[ticketId + '_' + index] = ref;
        },
        removeTicket(ticketId, index) {
	        this.store.commit('emitScroll');
            UIkit.modal.confirm(this.$t('Ticket entfernen?')).then(() => {
                delete this.personRefs[ticketId+'_'+index];
                this.store.commit("removeTicket", { ticketId, index });
                this.$forceUpdate();
                if (!Object.keys(this.selection).length) {
                    this.$emit("back");
                }
            }, () => {});
        },
        async validate() {
            // A removed ticket's form stays in personRefs (its key may now belong to another
            // ticket, the list is not keyed), and its $refs.form is null: only mounted forms count.
            const forms = new Set(Object.values(this.personRefs).filter(form => !form.$.isUnmounted));
            const promises = [...forms].map(form => form.validate())
            return Promise.all(promises).then((values) => {
                return values.every(Boolean);
            });
        },
    },
};
</script>
